import "./CaseStudyUrbanHotelIndiaRevenueOptimization.module.css";
import Header from "@/reusable_sections/Header";
import Casestudyhero from "./sections/Casestudyhero";
import RevenueMetrics from "./sections/RevenueMetrics";
import Revenue from "./sections/Revenue";
import Segmentperformancestats from "./sections/Segmentperformancestats";
import RevenueStrategy from "./sections/RevenueStrategy";
import Footer from "@/reusable_sections/Footer";
export default function CaseStudyUrbanHotelIndiaRevenueOptimizationPage() {
  return <div>
      <Header />
      <Casestudyhero />
      <RevenueMetrics />
      <Revenue />
      <Segmentperformancestats />
      <RevenueStrategy />
      <Footer />
    </div>;
}